export default {
  java: "http://39.99.237.105:6001/api",
  express: "http://39.99.237.105:7001/api"
  // express: "http://192.168.101.18:7001/api"
};
